import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c0ab073"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6c0ab073&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c0ab073')) {
      api.createRecord('6c0ab073', component.options)
    } else {
      api.reload('6c0ab073', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6c0ab073", function () {
      api.rerender('6c0ab073', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/auth/recoverPassword/index.vue"
export default component.exports